import React, { useState, useEffect, useContext } from "react";
import ReactSelect from "react-select";
import "../../styles/pages/enquiry/WorkshopChangePage.scss";
import Popup from "../../components/Popup";
import { enquiryContext } from "./Enquiry";
import { GlobalContext } from "../../App";
import { useForm, Controller } from "react-hook-form";
import { Trans, useTranslation } from "react-i18next";
import { changeWorkshop } from "../../api/apiManagement";

function WorkshopChangePage() {
  const {
    workshopChangeData,
    setCurrentStep,
    enquiryLoginData,
    handleEnquiry,
    workshopRecordId,
  } = useContext(enquiryContext);
  const { isLogin, setIsLoading } = useContext(GlobalContext);
  const { t, i18n } = useTranslation();
  const [openPopup, setOpenPopup] = useState(false);

  const [formData, setFormData] = useState([]);
  // State to track the last clicked dropdown
  const [isDisabledEvent, setIsDisabledEvent] = useState(true);
  const [isDisabledLocation, setIsDisabledLocation] = useState(false);
  const [isDisabledDate, setIsDisabledDate] = useState(true);
  const [isDisabledTime, setIsDisabledTime] = useState(true);

  const [dateList, setDateList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [timeList, setTimeList] = useState([]);
  const [currentData, setCurrentData] = useState();
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
    setValue,
    watch,
    getValues,
  } = useForm({});

  useEffect(() => {
    setFormData(workshopChangeData);
  }, []);

  useEffect(() => {
    setValue("eventName", workshopChangeData[0]);
  }, [formData]);

  //eventName
  useEffect(() => {
    if (formData && formData.length > 0) {
      setDateList(
        formData.filter((x) => x?.title === watch("eventName")?.title)
      );
    }
  }, [watch("eventName")]);

  //eventLocation

  useEffect(() => {
    if (dateList && dateList.length > 0) {
      setLocationList(
        dateList[0]?.workshop_location.filter(
          (x) => x?.address === watch("eventLocation")?.address
        )
      );
    }
  }, [watch("eventLocation")]);

  //eventDate
  useEffect(() => {
    if (locationList && locationList.length > 0) {
      setTimeList(
        locationList[0]?.workshop_date.filter(
          (x) => x?.date === watch("eventDate")?.date
        )
      );
    }
  }, [watch("eventDate")]);

  function handleClearDropdownData(n) {
    if (n === 0) {
      setValue("eventDate", "");
      setValue("eventLocation", "");
      setValue("eventTime", "");
      setIsDisabledLocation(false);
      setIsDisabledDate(true);
      setIsDisabledTime(true);
    } else if (n === 1) {
      setValue("eventDate", "");
      setValue("eventTime", "");
      setIsDisabledLocation(false);
      setIsDisabledDate(false);
      setIsDisabledTime(true);
    } else if (n === 2) {
      setValue("eventTime", "");
      setIsDisabledTime(false);
    } else {
    }
  }

  function handleChangeWorkshop(d) {
    setOpenPopup(true);

    let data = {
      id: workshopRecordId,
      workshop_detail_id: d.eventTime.workshop_detail_id,
      workshop_date: d.eventDate.date,
      email: enquiryLoginData?.email,
      phone: 852 + enquiryLoginData?.phone,
    };
    if (isLogin) {
      data.email = JSON.parse(localStorage.getItem("user_data"))?.email;
      data.phone = JSON.parse(localStorage.getItem("user_data"))?.phone;
      data.sua_id = JSON.parse(localStorage.getItem("user_data"))?.sua_id;
      data.token = JSON.parse(localStorage.getItem("jwt"))?.signature;
    }
    setCurrentData(data);
  }
  function submitForm() {
    setIsLoading(true);
    changeWorkshop(currentData)
      .then((res) => {
        const currentStatusCode = res.data.StatusCode;
        if (currentStatusCode === 200) {
          setCurrentStep(1);
          handleEnquiry();
        } else if (currentStatusCode === 500) {
        } else if (currentStatusCode === 502) {
        } else if (currentStatusCode === 504) {
        } else if (currentStatusCode === 505) {
        } else if (currentStatusCode === 601) {
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  }
  return (
    <div className="workshop-change-page-container">
      {openPopup ? (
        <Popup
          title={t("enquiry:popupTitle")}
          buttonLeftText={t("global:popupLeftText")}
          buttonRightText={t("global:popupRightText")}
          setOpenPopup={setOpenPopup}
          handleClick={() => {
            submitForm();
          }}
        />
      ) : (
        <></>
      )}
      <form className="form-container">
        {/**Event Name*/}
        <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>{" "}
                <Trans i18nKey="formPage:eventName" />
              </div>
            </div>
            <Controller
              name="eventName"
              control={control}
              rules={{ required: true }}
              render={({ field }) => {
                return (
                  <ReactSelect
                    {...field}
                    name="eventName"
                    classNamePrefix="filter"
                    options={workshopChangeData}
                    getOptionLabel={(option) => option.title}
                    getOptionValue={(option) => option.title}
                    placeholder=""
                    onChange={(x) => {
                      field.onChange(x);
                      // handleClearDropdownData(0);
                    }}
                    isDisabled={isDisabledEvent}
                  />
                );
              }}
            />
            {errors.eventName && (
              <span className="input-error-message">
                <Trans i18nKey="formPage:eventName_error" />
              </span>
            )}
          </div>
        </div>
        {/**Event Name*/}
        {/**Event Location*/}
        <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>{" "}
                <Trans i18nKey="formPage:eventLocation" />
              </div>
            </div>
            <Controller
              name="eventLocation"
              control={control}
              rules={{ required: true }}
              render={({ field }) => {
                return (
                  <ReactSelect
                    {...field}
                    classNamePrefix="filter"
                    options={dateList[0]?.workshop_location}
                    getOptionLabel={(option) => option?.address}
                    getOptionValue={(option) => option?.address}
                    placeholder=""
                    onChange={(x) => {
                      field.onChange(x);
                      handleClearDropdownData(1);
                    }}
                    isDisabled={isDisabledLocation}
                  />
                );
              }}
            />
            {errors.eventLocation && (
              <span className="input-error-message">
                <Trans i18nKey="validation:eventLocation_error" />
              </span>
            )}
          </div>
        </div>
        {/**Event Location*/} {/**Event Date*/}
        <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>{" "}
                <Trans i18nKey="formPage:eventDate" />
              </div>
            </div>
            <Controller
              name="eventDate"
              control={control}
              rules={{ required: true }}
              render={({ field }) => {
                return (
                  <ReactSelect
                    {...field}
                    classNamePrefix="filter"
                    options={locationList[0]?.workshop_date}
                    getOptionLabel={(option) => option?.date}
                    getOptionValue={(option) => option?.date}
                    placeholder=""
                    onChange={(x) => {
                      field.onChange(x);
                      handleClearDropdownData(2);
                    }}
                    isDisabled={isDisabledDate}
                  />
                );
              }}
            />

            {errors.eventDate && (
              <span className="input-error-message">
                <Trans i18nKey="validation:eventDate_error" />
              </span>
            )}
          </div>
        </div>
        {/**Event Date*/}
        {/**Event Time*/}
        <div className="input-row">
          <div className="input-container" style={{ width: "100%" }}>
            <div className="input-label-container">
              <div className="input-label">
                <span className="red-start">*</span>{" "}
                <Trans i18nKey="formPage:eventTime" />
              </div>
            </div>
            <Controller
              name="eventTime"
              control={control}
              rules={{ required: true }}
              render={({ field }) => {
                return (
                  <ReactSelect
                    {...field}
                    classNamePrefix="filter"
                    options={timeList[0]?.workshop_time}
                    getOptionLabel={(option) => option?.time_slot}
                    getOptionValue={(option) => option?.time_slot}
                    placeholder=""
                    onChange={(x) => {
                      field.onChange(x);
                      handleClearDropdownData(3);
                    }}
                    isDisabled={isDisabledTime}
                    isOptionDisabled={(option) => option.quota === 0}
                  />
                );
              }}
            />
            {errors.eventTime && (
              <span className="input-error-message">
               <Trans i18nKey="validation:eventTime_error" />
              </span>
            )}
          </div>
        </div>
        {/**Event Time*/}
      </form>
      <div>
        <button
          className="workshop-button"
          onClick={handleSubmit(handleChangeWorkshop)}
        >
          <Trans i18nKey="formPage:submit" />
        </button>
        <button className="workshop-button" onClick={() => setCurrentStep(1)}>
          <Trans i18nKey="formPage:back" />
        </button>
      </div>
    </div>
  );
}

export default WorkshopChangePage;
